import { useAppSelector } from "../../../../hooks/app";
import { AppAvatar, AppBox, AppButton, AppPaper, AppSkeletonHeader, AppTitle } from "../../../../commons/components";
import { StatusEnum } from "../../../../commons/enums/status-enum";
import { toTitleCase } from "../../../../commons/utilities/string-utils";
import { IUser } from "../../../../commons/models/i-user";

interface ProfileManageDetailHeaderProps {
  user: IUser;
  onEditProfile?: (event?: Event) => void;
}

export default function ProfileManageDetailHeader({ user, onEditProfile }: ProfileManageDetailHeaderProps) {
  const { stadiumInfoStatus } = useAppSelector((state) => state.manageStadium);
  return (
    <AppPaper shadow="xs" padding="none">
      {stadiumInfoStatus === StatusEnum.Loading ? (
        <AppSkeletonHeader withoutBackground />
      ) : (
        <AppBox alignItems="center" justifyContent="space-between" p="sm" gap="xs">
          <AppBox alignItems="center" gap="xs">
            <AppAvatar username={user?.fullName} size="2xl" src={user.avatar || ""} />
            <AppBox flexDirection="column" gap="3xs">
              <AppTitle as="h4">{toTitleCase(user?.fullName)}</AppTitle>
            </AppBox>
          </AppBox>
          <AppButton variant="light" label="Edit Profile" onClick={onEditProfile} />
        </AppBox>
      )}
    </AppPaper>
  );
}
